import { useState } from "react";
import Swal from "sweetalert2";

import api from "../services/api";
import Navbar from "../components/Navbar";
import { useAuth } from "../context/AuthContext";

function CreateCategory() {
  const { token } = useAuth();

  const [formData, setFormData] = useState({
    name: "",
    slug: "",
    description: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const resetForm = () => {
    setFormData({
      name: "",
      slug: "",
      description: ""
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      await api.post(
        "/categories",
        formData,
        {
          headers: {
            Authorization:
              `Bearer ${token}`
          }
        }
      );

      Swal.fire({
        icon: "success",
        title: "Success",
        text:
          "Category created successfully!",
        timer: 2000,
        showConfirmButton: false
      });

      resetForm();

    } catch (error) {

      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Creation Failed",
        text:
          error.response?.data?.message ||
          "Failed to create category"
      });

    }
  };

  return (
    <div>
      <Navbar />

      <div className="form-container">

        <h1>Create Category</h1>

        <form onSubmit={handleSubmit}>

          <input
            type="text"
            name="name"
            placeholder="Category Name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="slug"
            placeholder="Slug"
            value={formData.slug}
            onChange={handleChange}
            required
          />

          <textarea
            name="description"
            placeholder="Description"
            value={formData.description}
            onChange={handleChange}
          />

          <button type="submit">
            Create Category
          </button>

        </form>

      </div>
    </div>
  );
}

export default CreateCategory;